import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = ["textContent"]

import {ref} from "vue";
import Icon from "../Icon/Icon.vue";
import {IconName} from "../Icon/icons";

interface Props {
  label: string;
  icon?: IconName;
  testId?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckBox',
  props: /*@__PURE__*/_mergeModels({
    label: {},
    icon: {},
    testId: {}
  }, {
    "modelValue": {default: false},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose }) {

const props = __props;
const checked = _useModel(__props, "modelValue");

function toggle(): void {
  checked.value = !checked.value;
}

const element = ref<HTMLElement|null>();

function scrollIntoView(): void {
  element.value!.scrollIntoView({block: "nearest", inline: "nearest"});
}

function label(): string {
  return props.label;
}

__expose({scrollIntoView, label});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex items-center cursor-pointer",
    onClick: toggle,
    ref_key: "element",
    ref: element
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["size-5 rounded flex items-center flex-shrink-0 justify-center transition duration-200", checked.value ? 'bg-primary text-on-primary' : 'bg-tile-nested border-1 border-neutral2-200']),
      "data-testid": props.testId
    }, [
      (checked.value)
        ? (_openBlock(), _createBlock(Icon, {
            key: 0,
            name: "checkboxChecked"
          }))
        : _createCommentVNode("v-if", true)
    ], 10 /* CLASS, PROPS */, _hoisted_1),
    (props.icon)
      ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          class: "ml-2 flex-shrink-0",
          name: props.icon
        }, null, 8 /* PROPS */, ["name"]))
      : _createCommentVNode("v-if", true),
    (props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 1,
          class: "ml-2 flex-shrink-0 cursor-pointer",
          textContent: _toDisplayString(props.label)
        }, null, 8 /* PROPS */, _hoisted_2))
      : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}
}

})